import type { MessageCategory, MessagesPaths as paths } from '@core/types'
import type { MaybeRefOrGetter } from '#imports'

export enum NotificationIconType {
    Thermometer = 'thermometer',
    User = 'user',
    Notification = 'bell',
    Game = 'rocket',
    Withdrawal = 'payout'
}

export interface NotificationQueryParams {
    limit?: number
    offset?: number
    enabled?: MaybeRefOrGetter<boolean>
    lazy?: boolean
    exclude_read?: boolean
    exclude_expired?: boolean
    category?: `${MessageCategory}` | null
    useBaseQueryKey?: boolean
    key?: MaybeRefOrGetter<string>
    presentation_type?: `${paths['/v1/public/notifications']['get']['parameters']['query']['presentation_type']}`
}
